const links = [
  {
    label: 'Linkedin',
    url: 'https://www.linkedin.com/in/khenriqqe/',
  },
  {
    label: 'Github',
    url: 'https://github.com/keelviinn',
  },
  {
    label: 'Twitter',
    url: 'https://twitter.com/k_henriqqe',
  },
  {
    label: 'Youtube',
    url: 'https://www.youtube.com/channel/UCb1dHjTAPo1adyDYH0mU8FA',
  },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/k_henriqqe',
  },
];

export default links;
